import { Button, createStyleSheet, Icon, Text, ThemeContextProvider, useStyleSheet, useThemeContext, View } from '@gopeerproject/ui-kit';
import React from 'react';
import { Header } from './';
import { FileDownloader } from '../../FileDownloader';
import { humanizeFileSize } from '../../../helpers';
export const Generic = ({ file, onClose }) => {
    var _a;
    const styles = useStyleSheet(getStyles);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { file: file, onClose: onClose, isFixed: true }),
        React.createElement(View, { style: styles.container },
            React.createElement(ThemeContextProvider, { defaultColorScheme: 'light', forcedColorScheme: 'light' },
                React.createElement(Document, null)),
            React.createElement(Text, { type: 'body', size: 'lg', weight: 'regular' }, file.name.slice(0, file.name.lastIndexOf('.'))),
            React.createElement(Text, { weight: 'semibold', type: 'body', size: 'md', style: styles.details },
                ((_a = file.metadata) === null || _a === void 0 ? void 0 : _a.size) && `${humanizeFileSize(file.metadata.size)} ⋅ `,
                file.name.slice(file.name.lastIndexOf('.') + 1).toUpperCase()),
            React.createElement(FileDownloader, { name: 'file.name', href: file.data }, (download) => (React.createElement(Button, { leftIcon: 'arrow-download', type: 'primary', accent: 'default', size: 'lg', text: 'Download', onPress: download }))),
            React.createElement(Text, { weight: 'regular', type: 'body', size: 'md', style: styles.apology },
                "We are sorry, but ",
                file.name.slice(file.name.lastIndexOf('.')),
                " file preview is not supported at this time"))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: { alignItems: 'center', justifyContent: 'center', flexGrow: 1 },
    details: {
        color: color.white.p56,
        marginTop: size.B,
        marginBottom: size.K
    },
    apology: { marginTop: size.K, color: color.white.p56 }
}));
const Document = () => {
    const styles = useStyleSheet(getDocumentStyles);
    const { size } = useThemeContext();
    return (React.createElement(View, { style: styles.document },
        React.createElement(Icon, { name: 'document', size: size.L, color: (color) => color.invert2.p26 })));
};
const getDocumentStyles = createStyleSheet(({ color, size }) => ({
    document: {
        justifyContent: 'center',
        alignItems: 'center',
        width: size.P,
        height: size.P,
        backgroundColor: color.bg.v2,
        borderRadius: size.I,
        borderColor: color.invert2.p4,
        borderWidth: 1,
        borderStyle: 'solid',
        marginBottom: size.C
    }
}));
//# sourceMappingURL=Generic.js.map